export const SIZES = {
  tiny: "0.75rem",
  small: "1rem",
  normal: "1.25rem",
  medium: "1.5rem",
  large: "2rem",
  maxWidth: "600px",
  smallWidth: "300px",
}
